
import { put, call, takeEvery } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { startSubmit, stopSubmit } from 'redux-form'
import moment from 'moment'
import _ from 'lodash'

import * as commons from '../commons'
import * as actions from '../actions/kenmei'

function* handleInit(action) {


  const kenmeiCodes = yield call(commons.getKenmei)

  yield put(actions.reducerInit(kenmeiCodes.result))

}

export function* root() {
  yield takeEvery(actions.SYSTEM_INIT, handleInit);
}


// WEBPACK FOOTER //
// ./src/sagas/kenmei.js